import { render, staticRenderFns } from "./MenuDetail.vue?vue&type=template&id=670572b9&scoped=true&"
import script from "./MenuDetail.vue?vue&type=script&lang=js&"
export * from "./MenuDetail.vue?vue&type=script&lang=js&"
import style0 from "./MenuDetail.vue?vue&type=style&index=0&id=670572b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670572b9",
  null
  
)

export default component.exports